module.exports = {"350924100":"鳌阳镇","350924101":"斜滩镇","350924102":"南阳镇","350924103":"武曲镇","350924104":"犀溪镇","350924105":"平溪镇","350924106":"凤阳镇","350924107":"清源镇","350924200":"大安乡","350924201":"坑底乡","350924203":"竹管垅乡","350924205":"芹洋乡","350924206":"托溪乡","350924209":"下党乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/350924.json
// module id = 1241
// module chunks = 0